import type { FC } from "react";
import type { SavedOrdersListItem } from "../orderTypes";
import { List, ListItem, ListItemText } from "@mui/material";
import { labelForTodoItem, todoItemsOrder } from "./labelForTodoItem";

interface Props {
  readonly todos: SavedOrdersListItem["todos"];
}

const ReadonlyOrderTodos: FC<Props> = ({ todos }) => {
  if (!todos) {
    return null;
  }
  return (
    <List dense sx={{ listStyleType: "disc", pl: 2 }}>
      {todoItemsOrder
        .filter((key) => !todos[key])
        .map((key) => (
          <ListItem key={key} dense disablePadding sx={{ display: "list-item" }}>
            <ListItemText primary={labelForTodoItem(key)} />
          </ListItem>
        ))}
    </List>
  );
};

export default ReadonlyOrderTodos;
